import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { SevDeskCustomer } from "../types/customer";
import { Technician } from "../types/user";

export type UserManagementSlice = {
  selectedCustomer: Customer | null;
  customers: SevDeskCustomer[];
  initialCustomers: SevDeskCustomer[];
  customerUsers: Technician[];
  customerProperties: any[];
};

const initialState: UserManagementSlice = {
  selectedCustomer: null,
  customers: [],
  initialCustomers: [],
  customerUsers: [],
  customerProperties: [],
};

export const userManagementSlice = createSlice({
  name: "userManagement",
  initialState,
  reducers: {
    setSelectedCustomer(state, { payload }: PayloadAction<Customer>) {
      state.selectedCustomer = payload;
    },
    setCustomers(state, { payload }: PayloadAction<SevDeskCustomer[]>) {
      state.customers = payload;
    },
    setInitialCustomers(state, { payload }: PayloadAction<SevDeskCustomer[]>) {
      state.initialCustomers = payload;
    },
    setCustomerUsers(state, { payload }: PayloadAction<Technician[]>) {
      state.customerUsers = payload;
    },
    setCustomerProperties(state, { payload }: PayloadAction<any[]>) {
      state.customerProperties = payload;
    },
    editCustomerUser(state, { payload }: PayloadAction<any>) {
      state.customerUsers = state.customerUsers.map((user) =>
        user.id === payload.id ? payload : user
      );
    },
    resetState() {
      return { ...initialState };
    },
  },
});

export const userManagementActions = userManagementSlice.actions;
